import { render, staticRenderFns } from "./ListWidgetItem.vue?vue&type=template&id=5de3707f&scoped=true"
import script from "./ListWidgetItem.vue?vue&type=script&lang=js"
export * from "./ListWidgetItem.vue?vue&type=script&lang=js"
import style0 from "./ListWidgetItem.vue?vue&type=style&index=0&id=5de3707f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de3707f",
  null
  
)

export default component.exports